import {AsyncFeature, AsyncComponent} from '@modifi/code-splitting'
import DirectDebitReturnForm from './components/direct-debit-return-form'

import {
  MATCH_GROUP_INVOICE,
  MATCH_GROUP_PAYMENT,
  MATCH_TYPE_INVOICE_DD_RETURN,
  MATCH_TYPE_PAYMENT_DD_RETURN,
} from './constants'

const loader = () => null

export const boxMap = {
  [MATCH_GROUP_PAYMENT]: AsyncComponent({
    loader,
    importThunk: () => import(/* webpackChunkName: 'match-feature' */ './components/payment-box'),
    componentName: 'PaymentBox',
  }),
  [MATCH_GROUP_INVOICE]: AsyncComponent({
    loader: () => null,
    importThunk: () => import(/* webpackChunkName: 'match-feature' */ './components/invoice-box'),
    componentName: 'InvoiceBox',
  }),
}

export const listMap = {
  [MATCH_GROUP_PAYMENT]: AsyncFeature({
    loader,
    importThunk: () => import(/* webpackChunkName: 'payments-feature' */ '../payments'),
    componentName: 'PaymentList',
  }),
  [MATCH_GROUP_INVOICE]: AsyncFeature({
    loader,
    importThunk: () => import(/* webpackChunkName: 'invoices-feature' */ '../invoices'),
    componentName: 'InvoiceList',
  }),
}

export const formMap = {
  [MATCH_TYPE_PAYMENT_DD_RETURN]: DirectDebitReturnForm,
  [MATCH_TYPE_INVOICE_DD_RETURN]: DirectDebitReturnForm,
}
